import { Chrome } from '@uiw/react-color'

import { commonIcons } from '@apps-common/config/icons'
import { ButtonRoundSm } from '../elements'
import { VertSpacerSm } from '../layout'

export interface IProps {
  title: string
  defaultColor?: string
  onChange: (color: string) => void
  onClose: () => void
}

export const ColorPickerOverlay: React.FC<IProps> = ({ title, defaultColor, onChange, onClose }) => (
  <div className='bg-surface border border-border rounded-3xl overflow-hidden shadow'>
    <div className='flex items-center justify-between pl-[15px] pr-[10px] py-[5px]'>
      <span className='text-[0.85em] capitalize'>{title}</span>
      <ButtonRoundSm type='button' className='action-brand-solid !w-[28px] !h-[28px]' callback={onClose}>
        <commonIcons.close />
      </ButtonRoundSm>
    </div>
    <VertSpacerSm />
    <Chrome color={defaultColor} inputType={'hexa' as any} showAlpha={false} onChange={(c) => onChange(c.hex)} className='!border-none' />
  </div>
)
